import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { config } from '@xingternal/hops';
import { TextButtonRegularSmall as TextButton } from '@xingternal/malt-button';

import { getResetRequest } from './../formActions';

import PageviewTracker from '../../../Components/PageviewTracker/PageviewTracker';
import TextLoadingSkeleton from './../../../Components/LoadingSkeletons/TextLoadingSkeleton';
import Spacer from './../../../Components/Spacer/Spacer';
import StepCounter from './../../../Components/StepCounter/StepCounter';
import { CustomH, CustomP } from './../../../Components/CustomMalt/Typography';

import messages from './messages';

const Success = ({ history: { replace } }) => {
  const [newEmail, setNewEmail] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  useEffect(() => {
    const fetchResetRequest = async () => {
      const result = await getResetRequest(replace);
      if (!result) return;

      const { newEmail } = result;
      setNewEmail(newEmail);
      setIsLoading(false);

      return result;
    };

    fetchResetRequest();
  }, [replace]);

  if (isLoading) return <TextLoadingSkeleton />;

  return (
    <>
      <PageviewTracker
        pageName={'wbm/Welcome/login/recovery/account/confirmation_success'}
      />

      <StepCounter allComplete />

      <div data-qa={'malt-login-recovery-success'}>
        <CustomH testId={'login-recovery-success'}>
          <FormattedMessage {...messages.title} />
        </CustomH>
      </div>

      <CustomP>
        <FormattedMessage
          {...messages.description1}
          values={{ username: <b>{newEmail}</b> }}
        />
      </CustomP>

      <CustomP>
        <FormattedMessage {...messages.description2} />
      </CustomP>

      <CustomP>
        <FormattedMessage {...messages.description3} />
      </CustomP>

      <Spacer size={2} />

      <TextButton href={`${config.externalUrl}/support/contact/login`}>
        <FormattedMessage {...messages.furtherQuestionsText} />
      </TextButton>
    </>
  );
};

export default Success;
